import { useAuth } from '../../../../contexts/auth'
import { useEffect, useState } from 'react'
import { defaultDistance, defaultLocation } from '../../../search'

function useLocationFilter() {
  const [{ userDetails }] = useAuth()
  const [location, setLocation] = useState(defaultLocation)
  const [distance, setDistance] = useState(defaultDistance)
  const [showLocationModal, setShowLocationModal] = useState(false)

  const zipCode = userDetails?.zipCode
  const latitude = userDetails?.location?.lat
  const longitude = userDetails?.location?.lng

  useEffect(() => {
    if (zipCode) {
      setLocation((prev) => ({ ...prev, zipCode }))
    }

    if (latitude && longitude) {
      setLocation((prev) => ({ ...prev, latitude, longitude }))
    }
  }, [zipCode, latitude, longitude])

  return { location, distance, showLocationModal, setLocation, setDistance, setShowLocationModal }
}

export default useLocationFilter
